import React, { FunctionComponent } from 'react';
import { Icon, IconSize, IconType } from '../../misc/Icon/Icon';
import { prepareProps } from '../../utils/propUtils';
import {
  BaseDialogButton,
  BaseDialogButtonProps
} from '../BaseDialogButton/BaseDialogButton';

export type BaseDialogIconButtonProps = BaseDialogButtonProps & {
  iconName: string;
  iconType: IconType;
};

export const BaseDialogIconButton: FunctionComponent<BaseDialogIconButtonProps> =
  React.memo((props) => {
    const { iconName, iconType, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    return (
      <BaseDialogButton {...remainingProps}>
        <Icon
          name={iconName}
          type={iconType}
          size={IconSize.Large}
        ></Icon>
      </BaseDialogButton>
    );
  });
